export const homeObjOne = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "agency",
  headline: "PISO 1",
  description:
    "Manage Your Whole Business Using Time Management & Collaboration Tools, Reports, and More",
  buttonLabel: "Get Started",
  imgStart: "",
  img:
    "https://raw.githubusercontent.com/edgarrincon/standards/7ea7660fd8181baac402c92331cf7cc88cac086a/src/images/odooanalitic.svg",
  alt: "piso4",
  linkTo: "./contacts",
  buttonSize: "btn--wide",
  buttonColor: "blue",
};

export const homeObjTwo = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "agency",
  headline: "PISO 1",
  description:
    "Manage Your Whole Business Using Time Management & Collaboration Tools, Reports, and More",
  buttonLabel: "Get Started",
  imgStart: "start",
  img:
    "https://raw.githubusercontent.com/edgarrincon/standards/7ea7660fd8181baac402c92331cf7cc88cac086a/src/images/odooanalitic.svg",
  alt: "piso4",
  linkTo: "./contacts",
  buttonSize: "btn--wide",
  buttonColor: "blue",
};
